import { ROUTES_NAMES } from '@/constants';
import Logout from '@/views/Logout.vue';
import { beforeEnterLogoutRoute } from './logoutNavigationGuards';

const logoutRoute = {
  path: '/logout',
  name: ROUTES_NAMES.logout,
  component: Logout,
  beforeEnter: beforeEnterLogoutRoute
};

export default logoutRoute;
